/**
 * @name vector-polygon
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIuODI4IDQuODEzIDUuMzQ0IDIuMzc1IiAvPgogIDxwYXRoIGQ9Im0xNS43NjkgMTguMTUzIDMuNDYxLTguMzA2IiAvPgogIDxwYXRoIGQ9Im01LjY4NyAxNC4wNzQgNy42MjUgNC44NTIiIC8+CiAgPHBhdGggZD0iTTkuNzcyIDUuNTc5IDUuMjI4IDExLjQyIiAvPgogIDxjaXJjbGUgY3g9IjExIiBjeT0iNCIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSIxNSIgY3k9IjIwIiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjIwIiBjeT0iOCIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSI0IiBjeT0iMTMiIHI9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/vector-polygon
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const VectorPolygon: string = `
<svg
  class="lucide lucide-vector-polygon"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="m12.828 4.813 5.344 2.375" />
  <path d="m15.769 18.153 3.461-8.306" />
  <path d="m5.687 14.074 7.625 4.852" />
  <path d="M9.772 5.579 5.228 11.42" />
  <circle cx="11" cy="4" r="2" />
  <circle cx="15" cy="20" r="2" />
  <circle cx="20" cy="8" r="2" />
  <circle cx="4" cy="13" r="2" />
</svg>
`;

export default VectorPolygon;
